// extracted by mini-css-extract-plugin
export default {"tag":"SelectedItem-modules__tag__mxptU"};